import { useTranslation } from 'react-i18next';
import {
    Menu,
    Tag,
    Form,
    Input,
    Dropdown,
    Cascader,
    Select,
    Pagination,
} from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { useNavigate } from 'react-router-dom';
import IconNoData from '../../../../../assets/Images/icons/icon-no-data';
import { ROUTER } from '../../../../../constants/router';
import { SearchOutlined } from '@ant-design/icons';
import parse from 'html-react-parser';
import React, { useState, useEffect } from 'react';
import usePermission from '../../../../../hooks/usePermission';

const { Option } = Select;
const TemplateListCard = ({
    templateList,
    setCurrentSelectList,
    currentSelectList,
    setSearchValue,
    searchValue,
    searchConsentList,
    setSearchTemplateCategory,
    searchTemplateCategory,
    dataTotal,
    setOpenDelete,
    setConfirmDelete,
    setDataObject,
    setTemplateType,
}) => {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation('consent');
    const lang = i18n?.language;
    const [loading, setLoading] = useState(false);
    const [form] = useForm();
    const [trigger, setTrigger] = useState(false);
    const [searchBy, setSearchBy] = useState('modifyDate');
    const [sortOrder, setSortOrder] = useState('desc');
    const [displayValue, setDisplayValue] = useState(
        `${t('Update Date')} / ${t('Descending')}`
    );

    // Pagination state
    const [currentPage, setCurrentPage] = useState({
        page: 1,
        pageSize: 10,
        total: 0,
    });

    let templateCategory = [
        {
            name: t('AllTemplateCategory'),
            value: '',
        },
        {
            name: t('ConsentTemplate'),
            value: 'Consent',
        },
        {
            name: t('TermConditionTemplate'),
            value: 'Term',
        },
    ];

    const cascaderOptions = [
        {
            value: 'modifyDate',
            label: t('Update Date'),
            children: [
                {
                    value: 'asc',
                    label: t('Ascending'),
                },
                {
                    value: 'desc',
                    label: t('Descending'),
                },
            ],
        },
        {
            value: 'templateName',
            label: t('TemplateName'),
            children: [
                {
                    value: 'asc',
                    label: t('Ascending'),
                },
                {
                    value: 'desc',
                    label: t('Descending'),
                },
            ],
        },
    ];

    const keywordSearch = Form.useWatch('keyword', form);
    const templateCategorySearch = Form.useWatch('templateCategory', form);

    useEffect(() => {
        setSearchValue(keywordSearch);
        setSearchTemplateCategory(templateCategorySearch);

        const searchField =
            searchBy === 'templateName'
                ? `templateName${lang.charAt(0).toUpperCase() + lang.slice(1)}`
                : searchBy;
        setCurrentPage({
            page: 1,
            pageSize: 10,
        })
        searchConsentList({
            s: searchField,
            sd: sortOrder,
            templateName: keywordSearch,
            templateType: templateCategorySearch,
            p: 1,
            ps: currentPage.pageSize,
        });
        setLoading(false);
    }, [trigger]);

    useEffect(() => {
        setSearchValue(keywordSearch);
        setSearchTemplateCategory(templateCategorySearch);

        const searchField =
            searchBy === 'templateName'
                ? `templateName${lang.charAt(0).toUpperCase() + lang.slice(1)}`
                : searchBy;

        searchConsentList({
            s: searchField,
            sd: sortOrder,
            templateName: keywordSearch,
            templateType: templateCategorySearch,
            p: currentPage.page,
            ps: currentPage.pageSize,
        });
        setLoading(false);
    }, [currentPage]);

    const menu = (item) => (
        <Menu
            className="w-28"
            items={[
                {
                    className: 'hover:bg-[#EEE5FF]',
                    label: (
                        <button
                            onClick={() => {
                                navigate(
                                    `${
                                        ROUTER.CONSENT_MANAGEMENT
                                            .TEMPLATE_DESIGN
                                    }/${item?.templateType.toLowerCase()}/${
                                        item?.templateKey
                                    }`
                                );
                            }}
                        >
                            {t('Edit')}
                        </button>
                    ),
                },
                {
                    className: 'hover:bg-[#EEE5FF]',
                    label: (
                        <button
                            onClick={() => {
                                item?.status === 'Draft'
                                    ? setOpenDelete(true)
                                    : setConfirmDelete(true);
                                setDataObject(item);
                            }}
                        >
                            {t('Delete')}
                        </button>
                    ),
                },
            ]}
        />
    );

    const _getTagStatus = (item) => {
        switch (item?.status) {
            case 'Draft':
                return (
                    <Tag
                        className="rounded-xl text-center"
                        style={{ color: '#9A9A9A', borderColor: '#9A9A9A' }}
                    >
                        {item?.status} {item?.version}
                    </Tag>
                );
            case 'Published':
                return (
                    <Tag
                        className="rounded-xl text-center"
                        style={{ color: '#4ACE8F', borderColor: '#4ACE8F' }}
                    >
                        {item?.status} {item?.latestPublishVersion}
                    </Tag>
                );
            default:
                return <></>;
        }
    };

    const handleCascaderChange = (value, selectedOptions) => {
        const [newSearchBy, newSortOrder] = value;
        setSearchBy(newSearchBy);
        setSortOrder(newSortOrder);

        const newDisplayValue = `${t(
            newSearchBy === 'modifyDate' ? t('Update Date') : t('TemplateName')
        )} / ${t(newSortOrder === 'asc' ? t('Ascending') : t('Descending'))}`;

        const searchField =
            newSearchBy === 'templateName'
                ? `templateName${lang.charAt(0).toUpperCase() + lang.slice(1)}`
                : newSearchBy;

        setDisplayValue(newDisplayValue);
        searchConsentList({
            s: searchField,
            sd: newSortOrder,
            templateName: keywordSearch,
            templateType: templateCategorySearch,
            p: 1,
            ps: 10,
        });
    };
    const getCascaderValue = () => {
        return [searchBy, sortOrder];
    };

    const { isAuditor } = usePermission();

    return (
        <div className="w-full col-span-2 rounded-t-md">
            <div className="bg-white text-xs font-semibold text-gray-PHX px-3 pb-3 pt-3 border-b-2 border-t-0 border-x-0 border-solid border-b-[#ECECEC]">
                <p className="text-dark text-sm font-semibold">
                    {t('Search Filter')}
                </p>
                <Cascader
                    options={cascaderOptions}
                    onChange={handleCascaderChange}
                    allowClear={false}
                    size="large"
                    placeholder={false}
                    showArrow
                    className="w-full mb-4"
                    value={getCascaderValue()}
                ></Cascader>
                <Form
                    scrollToFirstError={{
                        behavior: 'smooth',
                        block: 'center',
                    }}
                    form={form}
                    onValuesChange={(value) => {
                        setTrigger(!trigger);
                    }}
                >
                    <Form.Item name="templateCategory" className="w-full mb-4">
                        <Select
                            placeholder={t('AllTemplateCategory')}
                            defaultValue={templateCategory[0]?.value}
                            size="large"
                        >
                            {templateCategory?.map((e, i) => (
                                <Option key={i} value={e.value}>
                                    {e.name}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item name={'keyword'} className={'m-0'}>
                        <Input
                            size="large"
                            placeholder={t('SearchTemplateName')}
                            prefix={<SearchOutlined />}
                        />
                    </Form.Item>
                </Form>
            </div>
            <div className="bg-white p-4 font-semibold text-xs text-right text-[#65707A]">
                {t('TotalItems', { length: dataTotal })}
            </div>
            {templateList?.length > 0 ? (
                <div className="bg-white overflow-y-auto overflow-x-hidden max-h-[60vh] pb-5 border-b-2 border-t-0 border-x-0 border-solid border-b-[#ECECEC]">
                    {templateList?.map((item, i) => (
                        <div
                            key={i}
                            className={`cursor-pointer custom-list-consent hover:bg-gray-50 ${
                                currentSelectList?.templateId ===
                                item.templateId
                                    ? 'select'
                                    : ''
                            }`}
                        >
                            <div />
                            <div
                                key={item?.consentId}
                                className="my-2 flex w-full items-center"
                            >
                                <button
                                    className="flex-1 space-y-1 py-4 text-left"
                                    onClick={() => {
                                        setCurrentSelectList(item);
                                        setTemplateType(item?.templateType);
                                    }}
                                >
                                    <div className="font-semibold text-gray-500 text-xs">
                                        {item?.templateType} Template
                                    </div>
                                    <p
                                        className="font-semibold text-purple-PHX text-base line-clamp-2 w-full whitespace-pre-wrap"
                                        style={{
                                            wordBreak: 'break-word',
                                        }}
                                    >
                                        {lang === 'en'
                                            ? parse(item?.templateNameEn) || '-'
                                            : parse(item?.templateNameTh) ||
                                              '-'}
                                    </p>
                                    <div className="flex items-center">
                                        {_getTagStatus(item)}
                                        <div
                                            className="text-[#F0536F] text-[12px] text-right"
                                            hidden={
                                                item?.version ===
                                                    item?.latestPublishVersion ||
                                                item?.status === 'Draft'
                                            }
                                        >
                                            <div className="flex items-center py-2">
                                                <svg
                                                    width="10"
                                                    height="11"
                                                    viewBox="0 0 10 11"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <circle
                                                        cx="5"
                                                        cy="5.5"
                                                        r="5"
                                                        fill={'#F0536F'}
                                                    />
                                                </svg>
                                                <span>&nbsp;&nbsp;</span>
                                                <div>
                                                    {t('InformationChanged')}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </button>
                                <div className="px-1 hover:opacity-80">
                                    <Dropdown
                                        disabled={isAuditor}
                                        placement="bottomCenter"
                                        arrow
                                        overlay={menu(item)}
                                        className="disabled:opacity-50 disabled:cursor-not-allowed"
                                    >
                                        <button>
                                            <svg
                                                width={32}
                                                height={32}
                                                viewBox="0 0 32 32"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <rect
                                                    width={32}
                                                    height={32}
                                                    rx={6}
                                                />
                                                <path
                                                    d="M19.75 16C19.75 17.0312 20.5937 17.875 21.625 17.875C22.6562 17.875 23.5 17.0313 23.5 16C23.5 14.9687 22.6563 14.125 21.625 14.125C20.5937 14.125 19.75 14.9687 19.75 16Z"
                                                    fill="#7B67FB"
                                                />
                                                <path
                                                    d="M17.875 16C17.875 14.9687 17.0313 14.125 16 14.125C14.9687 14.125 14.125 14.9687 14.125 16C14.125 17.0312 14.9687 17.875 16 17.875C17.0312 17.875 17.875 17.0313 17.875 16Z"
                                                    fill="#7B67FB"
                                                />
                                                <path
                                                    d="M12.25 16C12.25 14.9687 11.4063 14.125 10.375 14.125C9.34375 14.125 8.5 14.9687 8.5 16C8.5 17.0312 9.34375 17.875 10.375 17.875C11.4062 17.875 12.25 17.0313 12.25 16Z"
                                                    fill="#7B67FB"
                                                />
                                            </svg>
                                        </button>
                                    </Dropdown>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="bg-white overflow-y-auto overflow-x-hidden pb-5">
                    <div className="text-center text-sm space-y-2 my-48 py-2">
                        <IconNoData />
                        <p className="text-[#65707A] text-[14px]">
                            {t('No Data')}
                        </p>
                    </div>
                </div>
            )}
            <div className="flex justify-center py-4 bg-white rounded-b-md">
                <Pagination
                    current={currentPage?.page || 1}
                    pageSizeOptions={[10, 25, 50, 100]}
                    defaultPageSize={currentPage?.pageSize}
                    total={currentPage?.total || dataTotal}
                    onChange={(page, pageSize) => {
                        const pageValue = {
                            ...currentPage,
                            page: page,
                            pageSize: pageSize,
                        };
                        setLoading(true);
                        setCurrentPage(pageValue);
                    }}
                    showSizeChanger
                />
            </div>
        </div>
    );
};

export default TemplateListCard;
